import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import pub from './../../common/public';

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    }) // 默认localstorage
  ],
  state: {
    fromPage:'',
    searchBox:'',//公共搜索组件搜索框内容
    searchRes:'',//搜索结果页搜索框内容
    selectLi:'',//帮助中心侧边栏样式是否命中变量
    keyString:'-1',
    departmentId: "",
    loginInfo: {}, //登录参数信息
    userInfo: {}, //当前登录用户的信息
    routes: {},//当前用户的路由表
    accessRoutePage: {}, //当前用户路由导航总表
    sideBar: JSON.parse(localStorage.getItem("sideBar")) || true,
    messageHaveRead: true, //是否还有未读消息
    permissions: {},
  },
  getters: {
    userInfo: state => state.userInfo,
    routes: state => state.routes,
    sideBar: state => state.sideBar,
    accessRoutePage: state => state.accessRoutePage,
    permissions: state => state.permissions,
    messageHaveRead: state => state.messageHaveRead
  },
  mutations: {
    changefrompage(state, data){
      state.fromPage = data
    },
    changesearchRes(state, data){
      state.searchRes = data
    },
    changesearchBox(state, data){
      state.searchBox = data
    },
    changeSelectLi(state, data){
      state.selectLi = data
    },
    changeKeyString(state, data){
      state.keyString=data
    },
    kongKeyString(state, data){
      state.keyString=data
    },
    changeDepartmentID (state, newId) {
      state.departmentId = newId
    },
    setLoginInfo (state, payload) {
      state.loginInfo = payload
    },
    setUserInfo (state, payload) {
      // localStorage.setItem('userInfo', JSON.stringify(payload))
      //payload.roleID = 1
      state.userInfo = payload
    },
    setMessageHaveRead (state, messageHaveRead) {
      state.messageHaveRead = messageHaveRead
    },
    setRoutes (state, routes) {
      console.log("routes:---",routes)
      //sessionStorage.setItem('routes', JSON.stringify(routes))
      // 添加本地路由-个人中心
      routes.push({
        functionCategoryCode: "Personal",
        functionCategoryName: "個人中心",
        functionModules: [{
          functionModuleCode: "PersonalCenter",
          functionModuleName: "個人中心",
        }],
      })
      // 添加本地路由-帮助中心
      // routes.push({
      //   functionCategoryCode: "HelpCenter",
      //   functionCategoryName: "幫助中心",
      //   functionModules: [{
      //     functionModuleCode: pub.routeNameLists.HelpTerms,
      //     functionModuleName: "幫助中心_放盤條款"
      //   }, {
      //     functionModuleCode: pub.routeNameLists.HelpCharges,
      //     functionModuleName: "幫助中心_收費標準"
      //   }, {
      //     functionModuleCode: pub.routeNameLists.HelpCoinPayment,
      //     functionModuleName: "幫助中心_付款方式"
      //   }, {
      //     functionModuleCode: pub.routeNameLists.HelpFeature,
      //     functionModuleName: "幫助中心_功能介紹"
      //   }]
      // })
      // 给帮助中心添加功能介绍
      let item = routes.find(routeItem => routeItem.functionCategoryCode === pub.routeNameLists.HelpCenter)
      if (item) {
        item.functionModules.push({
          functionModuleCode: pub.routeNameLists.HelpFeature,
          functionModuleName: "幫助中心_功能介紹"
        })
      } else {
        routes.push({
          functionCategoryCode: pub.routeNameLists.HelpCenter,
          functionCategoryName: "幫助中心",
          functionModules: [{
            functionModuleCode: pub.routeNameLists.HelpFeature,
            functionModuleName: "幫助中心_功能介紹"
          }]
        })
      }
      //处理后台传过来的路由，增加routeId索引
      let accessRoutePages = {}
      for (let ritem of routes) {
        ritem.routeId = routes.indexOf(ritem) + 1
        if (ritem.functionCategoryCode === pub.routeNameLists.Message) {
          ritem.functionModules[0].functionModuleName = '通知'
        }
        let pageInfo = {
          nowPage: ritem.routeId,
          labelsPage: 1,
        }
        accessRoutePages[ritem.functionCategoryCode] = pageInfo
        
        for (let nitem of ritem.functionModules) {
          nitem.routeId = ritem.functionModules.indexOf(nitem) + 1
          nitem.icon = pub.routeIcons[nitem.functionModuleCode]
          let pageInfoRoute = {
            nowPage: ritem.routeId,
            labelsPage: nitem.routeId,
          }
          accessRoutePages[nitem.functionModuleCode] = pageInfoRoute
        }
      }
      state.routes = routes
      state.accessRoutePage = accessRoutePages
    },
    setPermissions (state, permissionList) {
      let permissions = {}
      for (let item of permissionList) {
        permissions[item.permissionsCode] = item
      }
      state.permissions = permissions
    },
    setSideBar (state, sideBar) {
      localStorage.setItem('sideBar', JSON.stringify(sideBar))
      state.sideBar = sideBar
    },
    resetVuex (state) {
      state.departmentId = ''
      state.loginInfo = {}
      state.userInfo = {}
      state.routes = {}
      state.accessRoutePage = {}
      state.accessRouteList = {}
      state.page = {}
      localStorage.removeItem('page')
      state.sideBar = true
      state.permissions = {}
      localStorage.removeItem('sideBar')
      state.permissions = {}
    },
  },
  actions: {
    setLoginInfo (ctx, loginInfo) {
      ctx.commit('setLoginInfo', loginInfo)
    },
    setUserInfo (ctx, userInfo) {
      ctx.commit('setUserInfo', userInfo)
    },
    setRoutes (ctx, routes) {
      ctx.commit('setRoutes', routes)
    },
    setSideBar (ctx, sideBar) {
      ctx.commit('setSideBar', sideBar)
    },
    setPermissions (ctx, permissions) {
      ctx.commit('setPermissions', permissions)
    },
    setMessageHaveRead (ctx, messageHaveRead) {
      ctx.commit('setMessageHaveRead', messageHaveRead)
    },
    resetVuex (ctx) {
      ctx.commit('resetVuex')
    },
  },
  modules: {
  }
})

